import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-4d0317b7"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "dialog-aquatic" }
const _hoisted_2 = { class: "header" }
const _hoisted_3 = { class: "title f-size-24 f-col-white08" }
const _hoisted_4 = { class: "body" }
const _hoisted_5 = { class: "left" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "header" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "title" }, "基础信息:")
], -1))
const _hoisted_7 = { class: "content" }
const _hoisted_8 = { class: "descriptions-item" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "key" }, "负责人：", -1))
const _hoisted_10 = { class: "value" }
const _hoisted_11 = { class: "descriptions-item" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "key" }, "养殖场名称：", -1))
const _hoisted_13 = { class: "value" }
const _hoisted_14 = { class: "descriptions-item" }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "key" }, "所属镇街：", -1))
const _hoisted_16 = { class: "value" }
const _hoisted_17 = { class: "descriptions-item" }
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "key" }, "联系方式：", -1))
const _hoisted_19 = { class: "value" }
const _hoisted_20 = { class: "descriptions-item" }
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "key" }, "详细地址：", -1))
const _hoisted_22 = { class: "value" }
const _hoisted_23 = { class: "descriptions-item" }
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "key" }, "受纳水体：", -1))
const _hoisted_25 = { class: "value" }
const _hoisted_26 = { class: "right" }
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "header" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "title" }, "饲养情况:")
], -1))
const _hoisted_28 = { class: "content" }
const _hoisted_29 = { class: "descriptions-item" }
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "key" }, "类 别：", -1))
const _hoisted_31 = { class: "value" }
const _hoisted_32 = { class: "descriptions-item" }
const _hoisted_33 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "key" }, "养 殖 类 型：", -1))
const _hoisted_34 = { class: "value" }
const _hoisted_35 = { class: "descriptions-item" }
const _hoisted_36 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "key" }, "养 殖 种 类：", -1))
const _hoisted_37 = { class: "value" }
const _hoisted_38 = { class: "descriptions-item" }
const _hoisted_39 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "key" }, "养殖面积（亩）：", -1))
const _hoisted_40 = { class: "value" }
const _hoisted_41 = { class: "descriptions-item" }
const _hoisted_42 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "key" }, "年生产能力（吨）：", -1))
const _hoisted_43 = { class: "value" }

import { toRefs, nextTick, getCurrentInstance, onMounted } from 'vue'

export default /*#__PURE__*/_defineComponent({
  __name: 'DialogAquatic',
  props: {
  data: Object,
},
  setup(__props) {

const props = __props
const { data } = toRefs(props)
console.log('data', data.value)

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, _toDisplayString(_unref(data).mc || '-'), 1)
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("div", _hoisted_5, [
        _hoisted_6,
        _createElementVNode("div", _hoisted_7, [
          _createElementVNode("div", _hoisted_8, [
            _hoisted_9,
            _createElementVNode("span", _hoisted_10, _toDisplayString(_unref(data).fzr || '-'), 1)
          ]),
          _createElementVNode("div", _hoisted_11, [
            _hoisted_12,
            _createElementVNode("span", _hoisted_13, _toDisplayString(_unref(data).mc || '-'), 1)
          ]),
          _createElementVNode("div", _hoisted_14, [
            _hoisted_15,
            _createElementVNode("span", _hoisted_16, _toDisplayString(_unref(data).szcj || '-'), 1)
          ]),
          _createElementVNode("div", _hoisted_17, [
            _hoisted_18,
            _createElementVNode("span", _hoisted_19, _toDisplayString(_unref(data).lxfs || '-'), 1)
          ]),
          _createElementVNode("div", _hoisted_20, [
            _hoisted_21,
            _createElementVNode("span", _hoisted_22, _toDisplayString(_unref(data).dz || '-'), 1)
          ]),
          _createElementVNode("div", _hoisted_23, [
            _hoisted_24,
            _createElementVNode("span", _hoisted_25, _toDisplayString(_unref(data).snst || '-'), 1)
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_26, [
        _hoisted_27,
        _createElementVNode("div", _hoisted_28, [
          _createElementVNode("div", _hoisted_29, [
            _hoisted_30,
            _createElementVNode("span", _hoisted_31, _toDisplayString(_unref(data).lb || '-'), 1)
          ]),
          _createElementVNode("div", _hoisted_32, [
            _hoisted_33,
            _createElementVNode("span", _hoisted_34, _toDisplayString(_unref(data).yzlx || '-'), 1)
          ]),
          _createElementVNode("div", _hoisted_35, [
            _hoisted_36,
            _createElementVNode("span", _hoisted_37, _toDisplayString(_unref(data).yzzl || '-'), 1)
          ]),
          _createElementVNode("div", _hoisted_38, [
            _hoisted_39,
            _createElementVNode("span", _hoisted_40, _toDisplayString(_unref(data).yzmj || '-'), 1)
          ]),
          _createElementVNode("div", _hoisted_41, [
            _hoisted_42,
            _createElementVNode("span", _hoisted_43, _toDisplayString(_unref(data).nscnl || '-'), 1)
          ])
        ])
      ])
    ])
  ]))
}
}

})